import Colors from '@digili-ui/constants/colors'
import { JSX, PropsWithChildren } from 'react'
import styled from 'styled-components'

import { Button } from '../actions/Button'
import { LogoIconType } from '../global/ComponentProps'
import { PAGE_COMPONENT_GAP } from '../global/constants'
import { SimplePageContentSection } from '../global/LayoutStyling'
import { SPACE_LARGE_PLUS, SPACE_SMALL } from '../global/spacing'
import { ChangeLanguageButtonOptions, PrimaryTopBarActionButtonOptions } from '../navigation/PrimaryTopBar'
import { PrimaryTopBar } from '../navigation/PrimaryTopBar/PrimaryTopBar'
import { PrimaryHeading } from '../typography/headings/PrimaryHeading'
import { WideContainer } from './WideContainer'

interface CatalogStepProps {
  actionBarOptions?: { label: string; onClick: () => void; icon: JSX.Element }
  actionButtonOptions: PrimaryTopBarActionButtonOptions
  changeLanguageOptions?: ChangeLanguageButtonOptions
  displayName?: string | undefined
  header: string
  ['data-testid']?: string
}

const Page = styled(SimplePageContentSection)`
  padding-top: 32px;
  padding-bottom: 52px;
  gap: ${PAGE_COMPONENT_GAP}px;
  align-items: flex-start;
  padding: ${SPACE_LARGE_PLUS} ${SPACE_SMALL} 52px ${SPACE_SMALL};
`

const ActionBarWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
`

export const CatalogStep = ({
  actionBarOptions,
  actionButtonOptions,
  changeLanguageOptions,
  children,
  displayName,
  header,
  'data-testid': dataTestId,
}: PropsWithChildren<CatalogStepProps>): JSX.Element => {
  return (
    <WideContainer data-testid={dataTestId}>
      <PrimaryTopBar
        actionButtonOptions={actionButtonOptions}
        bottomBorder={false}
        changeLanguageButtonOptions={changeLanguageOptions}
        icon={LogoIconType.SPankki}
        userDisplayName={displayName}
      />
      <Page $backgroundColor={Colors.BackgroundDefaultNeutral}>
        {actionBarOptions && (
          <ActionBarWrapper>
            <Button
              label={actionBarOptions.label}
              icon={actionBarOptions.icon}
              compact={true}
              variant={'plain'}
              color={'neutral'}
              onClick={actionBarOptions.onClick}
            />
          </ActionBarWrapper>
        )}
        <PrimaryHeading header={header} />
        {children}
      </Page>
    </WideContainer>
  )
}
